export default __webpack_public_path__ + "static/media/photo--lg--huda-4.1808dbb3.jpg";